<template>
  <div class="option-badge">
    <span class="option-badge__name">{{ optionName }}</span>
    <div class="option-badge__value-container">
      <span v-if="optionName === 'Color'" class="option-badge__image">
        <ImageField
          v-if="imageURL"
          :key="optionName"
          :obj="{ url: imageURL, alt: optionName, width: 20, height: 20 }"
        />
      </span>
      <span class="option-badge__value">{{ selectedValue }}</span>

      <div v-if="optionName === 'Condition'" class="option-badge__condition-tooltip-section">
        <TooltipModal customClass="bottom" v-model="isOpenTooltipModal">
          <template #tooltipContent>
            <div class="tooltip-content" role="tooltip" aria-live="polite">
              <div class="option-badge__tooltip-inner-wrapper">
                <button type="button" id="tooltipIconi" class="option-badge__tooltip-close" @click="toggleToolTip()">
                  <svg class="option-badge__tooltip-closeIcon">
                    <use xlink:href="#close"></use>
                  </svg>
                </button>
                <div class="option-badge__tooltip-title">Condition</div>
                <div class="option-badge__tooltip-content">
                  <div>
                    <p><strong>Excellent:</strong></p>
                    <p>Practically new; likely never worn outside</p>
                  </div>
                  <div>
                    <p><strong>Great:</strong></p>
                    <p>Trail-tested a few times; minor wear visible</p>
                  </div>
                  <div>
                    <p><strong>Good:</strong></p>
                    <p>Used for a season; visible wear</p>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <button class="option-badge__tooltip-icon" aria-label="Tooltip button">
            <svg class="option-badge__paymethods-tooltip">
              <use href="#tooltip-icon"></use>
            </svg>
          </button>
        </TooltipModal>
      </div>

    </div>
  </div>
</template>

<script setup>
  import { computed, ref, toRefs } from 'vue';
  import ImageField from '../global/image.vue';
  import TooltipModal from '../global/tooltip-modal.vue';

  const props = defineProps({
    group: Array,
    optionName: String,
    selectedValue: String,
  });

  const { optionName, selectedValue, group } = toRefs(props);
  const isOpenTooltipModal = ref(false);

  const imageURL = computed(() => {
    if (optionName.value === 'Color') {
      const imageUrl = group.value.flatMap((g) => g.options).find((opt) => opt.value === selectedValue.value)?.image;
      return imageUrl;
    }

    return undefined;
  });

  const toggleToolTip = () => {
    isOpenTooltipModal.value = !isOpenTooltipModal.value;
  };
</script>
